import moment from 'moment'

/**
 *  Formatting data - Calculated items count by Flyer code
 *  calculate unique value
 *  fill empty days depending on date
 * @param {object} data
 * @param {number} today current day
 * @param {number} endFilterDay the last day
 * @return {object} amount and group items by city
 */
export const formatScansData = ({ data, today, endFilterDay }) =>
  data.reduce(
    (acc, scanData, index, array) => {
      const scanDataKey = moment(Number(scanData.createdAt)).format(
        'YYYY-MM-DD',
      )
      if (endFilterDay && !index) {
        const endFilterDayMoment = moment(endFilterDay)
        const days = moment(Number(array[0].createdAt)).diff(
          moment(endFilterDay),
          'd',
          false,
        )

        if (days) {
          for (let i = 1; i <= days; i++) {
            const emptyDay = endFilterDayMoment.add(1, 'd').format('YYYY-MM-DD')

            acc.scans[emptyDay] = []
            acc.unique[emptyDay] = []
          }
        }
      }
      if (index) {
        const startDate = moment(Number(array[index - 1].createdAt))
        const endDate = moment(Number(scanData.createdAt))

        const days = endDate.diff(startDate, 'd', false)

        if (days) {
          for (let i = 1; i < days; i++) {
            const emptyDay = startDate.add(1, 'd').format('YYYY-MM-DD')
            acc.scans[emptyDay] = []
            acc.unique[emptyDay] = []
          }
        }
      }

      acc.scans[scanDataKey] = acc.scans[scanDataKey] || []
      acc.unique[scanDataKey] = acc.unique[scanDataKey] || []

      if (index === array.length - 1) {
        Object.keys(acc.scans).forEach(key => {
          if (acc.unique[key]) {
            acc.unique[key].push(
              ...new Set(
                acc.scans[key].map((item, index) =>
                  item.ipAddress ? item.ipAddress : index,
                ),
              ),
            )
          }
        })

        if (today) {
          const startFilterDayMoment = moment(
            Number(array[array.length - 1].createdAt),
          )
          const days = moment(today).diff(
            moment(startFilterDayMoment),
            'd',
            false,
          )

          if (days) {
            for (let i = 1; i <= days; i++) {
              const emptyDay = startFilterDayMoment
                .add(1, 'd')
                .format('YYYY-MM-DD')

              acc.scans[emptyDay] = []
              acc.unique[emptyDay] = []
            }
          }
        }
      }
      if (scanData.flyerCode) {
        acc.scans[scanDataKey].push(scanData)

        acc.amountScans += 1
        acc.amountUniqueScans = [
          ...new Set(Object.values(acc.unique).flat()),
        ].length
      }
      return acc
    },
    { scans: {}, unique: {}, amountScans: 0, amountUniqueScans: 0 },
  )

/**
 *  Get diff between 2 days
 * @param {number} value
 * @param {number} previousValue
 * @return {number} diff between values
 */
export const getDiffBetweenTwoDays = (value, previousValue) => {
  if (previousValue === null) {
    return null
  }
  if (!value && !previousValue) {
    return 0
  }
  if (!value && previousValue) {
    return -(previousValue * 100)
  }
  if (value && !previousValue) {
    return value * 100
  }
  return (value / previousValue) * 100 - 100
}

const formatNumber = value => Math.abs(value).toFixed(2)

export const renderScanUniqueGraphPopup = ({
  previousKey,
  currentDay,
  nextDay,
  scansAmount,
  uniqueAmount,
  isPositiveScans,
  diffScans,
  isPositiveUnique,
  diffUnique,
}) => `
                     <table>
                     <tr>
                       <td style="text-align: center; color: #7C7C7C; padding: 2px 58px 2px">${
                         previousKey
                           ? `${currentDay} vs. ${nextDay}`
                           : currentDay
                       }
                       </td>
                     </tr>
                     <tr>
                        <td style="text-align: center; color: #7C7C7C;  border-top: 0.25px solid #B4B4B4; padding: 7px 58px 2px">Scans - ${scansAmount}
                        <span style="color: #388849;"> ${
                          previousKey && isPositiveScans
                            ? `▲ ${formatNumber(diffScans)}%`
                            : ''
                        }</span> 
                    <span style="color: #EE4360;"> ${
                      previousKey && !isPositiveScans
                        ? `▼ ${formatNumber(diffScans)}%`
                        : ''
                    }</span>
                        </td>
                    </tr>
                    <tr>
                        <td style="text-align: center; vertical-align: middle; color: #7C7C7C;">Unique Scans - ${uniqueAmount}
                    <span style="color: #388849;"> ${
                      previousKey && isPositiveUnique
                        ? `▲ ${formatNumber(diffUnique)}%`
                        : ''
                    }</span> 
                    <span style="color: #EE4360;"> ${
                      previousKey && !isPositiveUnique
                        ? `▼ ${formatNumber(diffUnique)}%`
                        : ''
                    }</span>
                        </td>
                    </tr>
                  </table>
`



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/CampaignPerforming/Charts/ScanUniqueGraph/utils.js